// this mostly just exists as a badge on the event-level interaction bar
// hover-over for controls

import React from "react";
import Chip from "@mui/material/Chip";
import IntervalModel from "../../models/communications/Interval";
import Tooltip from "@material-ui/core/Tooltip";
import "./SchedulingMatrix/controls/styles/MatrixControls.css";
import IntervalControls from "./IntervalControls";
import InteractionParentInterval from "../../models/interactions/InteractionParentInterval";
import useHttp from "../../hooks/useHttp";
import { useStoreDispatch } from "../../store/Hooks";
import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";

const testing = process.env.REACT_APP_TEST_MODE === "test";

interface intervalProps {
  interval: IntervalModel;
  parentID: string | number | null;
  interactionParentInterval: InteractionParentInterval | null;
}

const Interval = (props: intervalProps) => {
  const { isLoading, sendRequest: fetchData } = useHttp();
  const dispatch = useStoreDispatch();

  // delete interval and all associated interaction_node_intervals
  const deleteInterval = async () => {
    // update db
    const url: string =
      process.env.REACT_APP_API_URL + "/interval?id=eq." + props.interval.id;
    const requestSettings = {
      url: url,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
        "Content-Type": "application/json",
        "Content-Profile": testing ? "test" : "build"
      },
    };
    if (process.env.REACT_APP_DEV_MODE === "OFF") {
      await fetchData(requestSettings);
    }
    // delete interaction and node from UI state
    dispatch(
      interactionTreeSliceActions.deleteInterval({
        id: props.interval.id,
      }),
    );
  };

  return (
    <Tooltip title={props.interval.name}>
      <Chip
        color="primary"
        label={
          <IntervalControls
            interactionParentInterval={props.interactionParentInterval}
            interval={props.interval}
            parentID={props.parentID}
          />
        }
        onDelete={deleteInterval}
      />
    </Tooltip>
  );
};

export default Interval;
